import * as React from "react";

interface IconProps extends React.HTMLAttributes<SVGElement> {
  size?: number;
}

export const Icons = {
  TGGroup: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="90"
      height="64"
      viewBox="0 0 90 64"
      fill="none"
    >
      <path
        d="M14.7567 24.3517C15.4926 21.7759 17.8469 20 20.5258 20H78.0456C82.0319 20 84.9099 23.8154 83.8148 27.6483L75.2433 57.6483C74.5074 60.2241 72.1531 62 69.4742 62H11.9544C7.96811 62 5.09012 58.1846 6.18524 54.3517L14.7567 24.3517Z"
        fill="url(#paint0_linear_399_5879)"
      />
      <path
        d="M70 10H5V48.0235C5.02754 47.9161 5.05741 47.8086 5.08963 47.7012L12.2896 23.7012C13.3048 20.3173 16.4194 18 19.9522 18H73.2478C73.5021 18 73.7529 18.0116 74 18.0343V14C74 11.7909 72.2091 10 70 10Z"
        fill="#3F9FF4"
      />
      <path
        d="M5 7C5 4.79086 6.79086 3 9 3H29.3118C30.36 3 31.3322 3.54708 31.8761 4.44307L39.5 17H5V7Z"
        fill="#3F9FF4"
      />
      <defs>
        <linearGradient
          id="paint0_linear_399_5879"
          x1="45"
          y1="20"
          x2="45"
          y2="62"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#7AC1FF" />
        </linearGradient>
      </defs>
    </svg>
  ),
  TGFolder: ({ size = 22, ...props }: IconProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      {...props}
    >
      <path
        d="M16.667 5.00004H9.16699L7.50033 3.33337H3.33366C2.41699 3.33337 1.66699 4.08337 1.66699 5.00004V8.33337H18.3337V6.66671C18.3337 5.75004 17.5837 5.00004 16.667 5.00004Z"
        fill="#E5B141"
      />
      <path
        d="M16.667 5H3.33366C2.41699 5 1.66699 5.75 1.66699 6.66667V15C1.66699 15.9167 2.41699 16.6667 3.33366 16.6667H16.667C17.5837 16.6667 18.3337 15.9167 18.3337 15V6.66667C18.3337 5.75 17.5837 5 16.667 5Z"
        fill="#F7BF46"
      />
    </svg>
  ),
  TGWorld: ({ size = 22, ...props }: IconProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={(42 / 46) * size}
      viewBox="0 0 46 42"
      fill="none"
      {...props}
    >
      <g filter="url(#filter0_dd_9266_76735)">
        <path
          d="M38.2146 6H16.1213C15.3188 6 14.668 6.65083 14.668 7.45333V13.5025H39.668V7.45333C39.668 6.65083 39.0171 6 38.2146 6Z"
          fill="#2D92D4"
        />
        <path
          d="M14.668 28.5449V34.5466C14.668 35.3491 15.3188 35.9999 16.1205 35.9999H38.2146C39.0171 35.9999 39.668 35.3491 39.668 34.5466V28.5449H14.668Z"
          fill="#2150A9"
        />
        <path
          d="M14.668 13.502H39.668V21.0036H14.668V13.502Z"
          fill="#2D83D4"
        />
        <path
          d="M14.668 21.0039H39.668V28.5456H14.668V21.0039Z"
          fill="#2E70C9"
        />
        <path
          d="M21.5979 29.3327H7.73286C6.95953 29.3327 6.33203 28.7052 6.33203 27.9318V14.0668C6.33203 13.2935 6.95953 12.666 7.73286 12.666H21.5979C22.3712 12.666 22.9987 13.2935 22.9987 14.0668V27.9318C22.9987 28.7052 22.3712 29.3327 21.5979 29.3327Z"
          fill="#00488D"
        />
        <path
          d="M18.3355 16.834L17.0472 22.8873L15.6197 16.834H13.7972L12.3247 23.0748L10.9972 16.834H9.36719L11.3205 25.1673H13.2805L14.708 18.7598L16.1364 25.1673H18.0122L19.9655 16.834H18.3355Z"
          fill="white"
        />
      </g>
      <defs>
        <filter
          id="filter0_dd_9266_76735"
          x={-3}
          y={-5}
          width={52}
          height={52}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood
            floodOpacity={0}
            result="BackgroundImageFix"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={2} />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9266_76735"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation={3} />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.02 0"
          />
          <feBlend
            mode="normal"
            in2="effect1_dropShadow_9266_76735"
            result="effect2_dropShadow_9266_76735"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect2_dropShadow_9266_76735"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  ),
  TGOneNote: ({ size = 22, ...props }: IconProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={(42 / 46) * size}
      viewBox="0 0 46 42"
      fill="none"
      {...props}
    >
      <g filter="url(#filter0_dd_9266_76723)">
        <path
          d="M16.1213 6C15.3188 6 14.668 6.65083 14.668 7.45333V34.5475C14.668 35.3492 15.3188 36 16.1205 36H32.168V6H16.1213Z"
          fill="#D56EFF"
        />
        <path
          d="M38.2146 6H32.168V13.5025H39.668V7.45333C39.668 6.65083 39.0171 6 38.2146 6Z"
          fill="#B854E5"
        />
        <path
          d="M32.168 28.5449V35.9999H38.2155C39.0171 35.9999 39.668 35.3491 39.668 34.5474V28.5458L32.168 28.5449Z"
          fill="#5E25A0"
        />
        <path
          d="M32.168 13.502H39.668V21.0036H32.168V13.502Z"
          fill="#A23ADF"
        />
        <path
          d="M32.168 21.0039H39.668V28.5456H32.168V21.0039Z"
          fill="#8026D1"
        />
        <path
          d="M21.5979 29.3327H7.73286C6.95953 29.3327 6.33203 28.7052 6.33203 27.9318V14.0668C6.33203 13.2935 6.95953 12.666 7.73286 12.666H21.5979C22.3712 12.666 22.9987 13.2935 22.9987 14.0668V27.9318C22.9987 28.7052 22.3712 29.3327 21.5979 29.3327Z"
          fill="#6517A3"
        />
        <path
          d="M16.7514 16.834V22.9948L12.8164 16.834H10.9922V25.1673H12.583V18.959L16.5489 25.1673H18.3422V16.834H16.7514Z"
          fill="white"
        />
      </g>
      <defs>
        <filter
          id="filter0_dd_9266_76723"
          x={-3}
          y={-5}
          width={52}
          height={52}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood
            floodOpacity={0}
            result="BackgroundImageFix"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={2} />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9266_76723"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation={3} />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.02 0"
          />
          <feBlend
            mode="normal"
            in2="effect1_dropShadow_9266_76723"
            result="effect2_dropShadow_9266_76723"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect2_dropShadow_9266_76723"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  ),
  TGExcel: ({ size = 22, ...props }: IconProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={(42 / 46) * size}
      viewBox="0 0 46 42"
      fill="none"
      {...props}
    >
      <g filter="url(#filter0_dd_9266_76704)">
        <path
          d="M27.168 6H16.1213C15.3188 6 14.668 6.65083 14.668 7.45333V13.5025H27.168V6Z"
          fill="#169154"
        />
        <path
          d="M14.668 28.5449V34.5466C14.668 35.3491 15.3188 35.9999 16.1205 35.9999H27.168V28.5449H14.668Z"
          fill="#18482A"
        />
        <path
          d="M14.668 13.502H27.168V21.0036H14.668V13.502Z"
          fill="#0C8045"
        />
        <path
          d="M14.668 21.0039H27.168V28.5456H14.668V21.0039Z"
          fill="#17472A"
        />
        <path
          d="M38.2146 6H27.168V13.5025H39.668V7.45333C39.668 6.65083 39.0171 6 38.2146 6Z"
          fill="#29C27F"
        />
        <path
          d="M27.168 28.545V36H38.2155C39.0171 36 39.668 35.3492 39.668 34.5475V28.5459L27.168 28.545Z"
          fill="#27663F"
        />
        <path
          d="M27.168 13.5029H39.668V21.0046H27.168V13.5029Z"
          fill="#19AC65"
        />
        <path
          d="M27.168 21.0039H39.668V28.5456H27.168V21.0039Z"
          fill="#129652"
        />
        <path
          d="M21.5979 29.3327H7.73286C6.95953 29.3327 6.33203 28.7052 6.33203 27.9318V14.0668C6.33203 13.2935 6.95953 12.666 7.73286 12.666H21.5979C22.3712 12.666 22.9987 13.2935 22.9987 14.0668V27.9318C22.9987 28.7052 22.3712 29.3327 21.5979 29.3327Z"
          fill="#0C7238"
        />
        <path
          d="M11.1717 16.834H13.16L14.7733 19.9623L16.4783 16.834H18.3358L15.7767 21.0007L18.3942 25.1673H16.435L14.6767 21.8923L12.9258 25.1673H10.9375L13.5983 20.9857L11.1717 16.834Z"
          fill="white"
        />
      </g>
      <defs>
        <filter
          id="filter0_dd_9266_76704"
          x={-3}
          y={-5}
          width={52}
          height={52}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood
            floodOpacity={0}
            result="BackgroundImageFix"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={2} />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9266_76704"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation={3} />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.02 0"
          />
          <feBlend
            mode="normal"
            in2="effect1_dropShadow_9266_76704"
            result="effect2_dropShadow_9266_76704"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect2_dropShadow_9266_76704"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  ),
  TGPowerpoint: ({ size = 22 }: IconProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={(42 / 46) * size}
      viewBox="0 0 46 42"
      fill="none"
    >
      <g filter="url(#filter0_dd_9266_76743)">
        <path
          d="M9.66797 21C9.66797 29.2842 16.3838 36 24.668 36C32.9521 36 39.668 29.2842 39.668 21H24.668H9.66797Z"
          fill="#DC4C2C"
        />
        <path
          d="M24.668 6V21H39.668C39.668 12.7158 32.9521 6 24.668 6Z"
          fill="#F7A278"
        />
        <path
          d="M24.668 6C16.3838 6 9.66797 12.7158 9.66797 21H24.668V6Z"
          fill="#C06346"
        />
        <path
          d="M21.5979 29.3327H7.73286C6.95953 29.3327 6.33203 28.7052 6.33203 27.9318V14.0668C6.33203 13.2935 6.95953 12.666 7.73286 12.666H21.5979C22.3712 12.666 22.9987 13.2935 22.9987 14.0668V27.9318C22.9987 28.7052 22.3712 29.3327 21.5979 29.3327Z"
          fill="#9B341F"
        />
        <path
          d="M15.2262 16.8438H11.332V25.1771H13.0187V22.2429H14.9154C16.4787 22.2429 17.7462 20.9754 17.7462 19.4121V19.3637C17.7462 17.9721 16.6179 16.8438 15.2262 16.8438ZM15.9737 19.6321C15.9737 20.3479 15.3929 20.9288 14.677 20.9288H13.0187V18.1579H14.677C15.3929 18.1579 15.9737 18.7388 15.9737 19.4546V19.6321Z"
          fill="white"
        />
      </g>
      <defs>
        <filter
          id="filter0_dd_9266_76743"
          x="-3"
          y="-5"
          width="52"
          height="52"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood
            floodOpacity="0"
            result="BackgroundImageFix"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="2" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9266_76743"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="3" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.02 0"
          />
          <feBlend
            mode="normal"
            in2="effect1_dropShadow_9266_76743"
            result="effect2_dropShadow_9266_76743"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect2_dropShadow_9266_76743"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  ),
  EmptyBox: () => (
    <svg
      width="99"
      height="96"
      viewBox="0 0 99 96"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink=" http://www.w3.org/1999/xlink"
    >
      <path
        fill="url(#a)"
        d="M0 0h99v96H0z"
      />
      <defs>
        <pattern
          id="a"
          patternContentUnits="objectBoundingBox"
          width="1"
          height="1"
        >
          <use
            xlinkHref="#b"
            transform="matrix(.00495 0 0 .0051 -.005 -.02)"
          />
        </pattern>
        <image
          id="b"
          width="204"
          height="196"
          xlinkHref="data:image/png;base64,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"
        />
      </defs>
    </svg>
  ),
};
